export default __webpack_public_path__ + "static/heading_bg-16cb37145a71b05664acd6ebb36854da.jpg";